import { defineMessages } from "react-intl";

export default defineMessages({
    drawer: {
        id: "drawer",
        defaultMessage: "Drawer"
    }
});